import React, { useState } from 'react';
import { footer } from '../../data/mock';
import { ChevronUp, Send } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (email) {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/subscribe`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        });
        if (!response.ok) throw new Error('Failed');
        setSubscribed(true);
        setEmail('');
        setTimeout(() => setSubscribed(false), 5000);
      } catch (error) {
        console.error('Subscribe error:', error);
        window.location.href = `mailto:rudy@prosafefireprotection.com?subject=Newsletter Subscription&body=Please add my email to your newsletter: ${email}`;
      }
    }
  };

  return (
    <footer className="bg-[#2a2a2a]">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-col items-center">
          {/* Logo */}
          <img 
            src={footer.logo} 
            alt="Prosafe Logo" 
            className="h-20 w-auto mb-8"
            loading="lazy"
          />
          
          <p className="font-roboto text-gray-400 text-sm sm:text-base text-center max-w-2xl mb-8 leading-relaxed">
            {t('footer.subscriptionText')}
          </p>

          {/* Email Subscription Form */}
          <form onSubmit={handleSubscribe} className="w-full max-w-md">
            <div className="relative flex">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="SUBSCRIBE | Your email"
                className="w-full bg-transparent border border-gray-600 text-white placeholder-gray-500 font-roboto text-sm py-6 px-4 pr-14 focus:border-[#e21b1b] focus:ring-0 rounded-none"
              />
              <Button
                type="submit"
                className="absolute right-0 top-0 bottom-0 bg-[#1a1a1a] hover:bg-[#e21b1b] text-white px-4 border border-gray-600 border-l-0 rounded-none transition-colors duration-300"
              >
                <Send className="w-4 h-4" />
              </Button>
            </div>
          </form>
        </div>

        {/* Scroll to Top Button */}
        <div className="flex justify-end mt-12">
          <button
            onClick={scrollToTop}
            className="w-12 h-12 bg-[#1a1a1a] hover:bg-[#e21b1b] text-white flex items-center justify-center transition-colors duration-300 group"
            aria-label="Scroll to top"
          >
            <ChevronUp className="w-6 h-6 group-hover:-translate-y-0.5 transition-transform duration-300" />
          </button>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="bg-[#e21b1b] py-4">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-roboto text-white text-xs sm:text-sm text-center tracking-wide">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
